<template>
    <div>
        <v-card style="" class="pb-3 pt-1 px-2 voicemails">
            <v-progress-linear
                v-if="loading"
                :indeterminate="true"
                color="success"
            ></v-progress-linear>
            <div v-if="!loading">
                <v-layout
                    v-if="!voicemails.length"
                    justify-center
                    align-center
                    class="mt-5 headline"
                >
                    No Voicemails
                </v-layout>
                <div v-if="voicemails.length">
                    <div v-for="voicemail in voicemails">
                        <v-card class="pb-1 pt-3 px-3 my-3">
                            <v-layout row class="mb-2 ml-2">
                                <div class="width-350">
                                    <div class="mt-2 font-weight-regular">
                                        {{ voicemail.date | time }}
                                    </div>
                                    <div class="mt-2">
                                        <span class="font-weight-medium"
                                            >Caller ID:</span
                                        >
                                        {{ voicemail.callerID | phone }}
                                    </div>
                                </div>

                                <audio
                                    class="mt-2 width-300"
                                    controls
                                    :src="voicemail.recordingURL"
                                    v-if="!voicemail.isAccountPhone"
                                ></audio>
                                <v-spacer></v-spacer>
                                <div
                                    v-if="voicemail.read"
                                    class="px-2 py-1"
                                    style="color: #fff; height: 33px; background-color: #4caf50;"
                                >
                                    Read
                                </div>
                            </v-layout>
                        </v-card>
                    </div>
                </div>
                <v-layout justify-center>
                    <v-pagination
                        v-model="pagination.page"
                        :length="pages"
                        :total-visible="7"
                        v-on:input="setPagianation"
                    ></v-pagination>
                </v-layout>
            </div>
        </v-card>
    </div>
</template>
<script>
import moment from "moment";

export default {
    props: {
        studentID: String,
    },
    data() {
        return {
            pagination: {
                totalCount: 0,
                rowsPerPage: 5,
                page: 1,
            },

            loading: true,
            voicemails: [],
            allVoicemails: [],
        };
    },
    watch: {},
    async created() {
        await this.loadVoicemails();
    },
    mounted() {},
    beforeDestroy() {},
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.allVoicemails.length / this.pagination.rowsPerPage
                  )
                : 0;
        },
    },
    methods: {
        async loadVoicemails() {
            const voicemails = await this.$http.get(
                "api/campStudents/getVoicemails?studentID=" +
                    this.$route.params.id
            );

            this.allVoicemails = voicemails;
            this.voicemails = this.allVoicemails.slice(0, 5);
            this.loading = false;
        },
        formatDuration(duration) {
            return moment("2015-01-01")
                .startOf("day")
                .seconds(duration)
                .format("H:mm:ss");
        },
        setPagianation() {
            if (this.getSkip() >= this.pagination.totalCount) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.voicemails = this.allVoicemails.slice(
                number,
                number + this.pagination.rowsPerPage
            );
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.pagination.totalCount) {
                skip = this.pagination.totalCount - this.pagination.rowsPerPage;
            }

            return skip;
        },
        getVoicemailCount() {
            return this.allVoicemails.length;
        },
    },
};
</script>
<style>
.voicemails {
    background-color: #f1ffdc !important;
    /*height: 350px;
    overflow-y: auto;*/
}
</style>
